<script>
import { map } from "lodash";
import Treeselect from "@riophae/vue-treeselect";
import RawData from "@/components/widgets/raw-data.vue";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
    components: {
        Treeselect,
        RawData
    },
    props: {
      objectOfExpenditures: null,
      availableAccounts: Array,
      oeTableBusy: null,
      template: Number,
      accountLoading: Boolean,
    },
    data() {
        return {
            fields: [
                // {
                //     key: "uacs",
                //     label: "UACS",
                // },
                {
                    key: "group",
                    label: "Account name",
                },
                {
                    key: "allocation",
                    label: "Allocation",
                    tdClass: "text-info text-end",
                    thClass: "text-end",
                },
                // {
                //     key: "balance",
                //     label: "Balance",
                //     tdClass: "text-end",
                //     thClass: "text-end",
                // },
                {
                    key: "actions",
                    label: "Actions",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: ["accountGroup.groupName"],
            sortBy: "account",
            sortDesc: false,
            addModal: false,
            availableAccountsConsist: "LEAF_PRIORITY",
            newData: [],
        };
    },
    computed: {
        rows() {
            return this.objectOfExpenditures.length;
        },
        totalAmt() {
          let sum = 0;
          this.objectOfExpenditures.forEach((item) => {
            sum += item.allocated;
          });
          return sum;
        }
    },
    methods: {
        onFiltered(filteredItems) {
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },
        async addOOE(){
          this.$emit('refresh-available');
          this.addModal = true;
        },
        checkExpiry(data) {
            return new Date() < new Date(data) ? true : false;
        },
        formatCurrency(data) {
            return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "PHP",
            }).format(data);
        },
        viewTransactions(row) {
            this.$emit("viewTransactions", row);
        },
        deleteItem(row) {
          // if (row.item.objectOfExpenditureTransactions.length > 0) {
          //   return this.showToast("Cannot delete item with existing transactions", "error");
          // } 
          this.$emit("deleteItem", row);
        },
        filterTable(row, filter) {
            if (row.groupName.toLowerCase().includes(filter.toLowerCase())) {
                return true;
            } else {
                return false;
            }
        },
        print(id) {
            this.$emit("print", id);
        },
        saveAccounts() {
            const data = this.newData.map((item) => ({
                financeTemplateId: this.template,
                accountGroupId: item
            }));
            this.$store
                .dispatch("financeTemplate/createMultipleTemplateExpenditures", data)
                .then((res) => {
                    if(res.data.error){
                      return this.showToast(res.data.errorMessage, "error")
                    }
                    this.$emit('refreshData');
                    this.showToast("Successfully added new accounts", "success");
                    this.clear();
                    this.addModal = false;
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong. Cannot save Object of Expenditures",
                        "error"
                    );
                });
        },
        clear() {
            this.newData = [];
            this.addModal = false;
        },
    },
};
</script>

<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div>
        <label
            class="d-inline-flex align-items-center mb-0 me-1"
        >
            <b-form-input v-model="filter"
                type="search"
                placeholder="Search account name..."
                class="form-control form-control-sm" 
                style="width:300px">
            </b-form-input>
            <b-form-select
                class="form-select form-select-sm ms-1 w-25"
                v-model="perPage"
                :options="pageOptions"
            ></b-form-select>
            <div class="d-flex no-wrap ms-2 fs-5"> Overall Total: <span class="text-warning ms-1">{{formatCurrency(totalAmt)}}</span></div>
        </label>
      </div>
      <button type="button" class="btn btn-primary btn-sm" @click="addOOE"><i class="bx bx-plus me-1"></i>Add OOE</button>
    </div>
    <div class="custom-table-responsive mb-0">
      <b-table :items="objectOfExpenditures"
               :fields="fields"
               :per-page="perPage"
               :current-page="currentPage"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :filter="filter"
               :filter-function="filterTable"
               :busy="oeTableBusy"
               @filtered="onFiltered"
               bordered
               outlined
               striped
               show-empty
               selected-variant="success">
        <template #empty="scope">
          <div class="text-center">{{ scope.emptyText }}</div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(uacs)="row">
          <span class="badge rounded-pill badge-soft-info">{{
            row.item.account ? row.item.account.uacs : "-"
          }}</span>
        </template>
        <template #cell(allocation)="row">
          {{
            row.item.allocated ? formatCurrency(row.item.allocated) : formatCurrency(0)
          }}
        </template>

        <template #cell(group)="row">
          <div class="position-relative">
            <RawData :data="row.item" v-if="$store.state.decrypt.isAdmin()" :keyId="`A${row.item.groupId}`"/>
          {{ row.item.groupName }}
          </div>
        </template>
        <template #cell(actions)="row">
          <b-button 
            variant="link"
            size="sm"
            :id="`popover-target-${row.item.groupId}`">
            <i class="fas fa-ellipsis-h"></i>
          </b-button>
          <b-popover 
            :target="`popover-target-${row.item.groupId}`"
            id="menu"
            triggers="hover blur"
            placement="leftbottom"
            variant="secondary"
            custom-class="p-0 p-custom-class"
          >
            <b-list-group class="w-100 fit">
              <b-list-group-item 
                button
                action
                @click="print(row.item.groupId)">
                <i class="bx bx-printer align-middle me-2 font-size-16 text-info"></i><span class="align-middle">Print RAOS</span>
              </b-list-group-item>
              <b-list-group-item 
                button
                action
                @click="deleteItem(row.item)"
              >
                <i class="mdi mdi-trash-can align-middle me-2 font-size-16 text-danger"></i><span class="align-middle">Delete</span>
              </b-list-group-item>
            </b-list-group>
          </b-popover>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-sm mb-0">
            <!-- pagination -->
            <b-pagination v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"></b-pagination>
          </ul>
        </div>
      </div>
    </div>
    <b-modal 
        v-model="addModal"
        size="lg"
        title="Select accounts"
        no-close-on-backdrop
    >
      <div v-if="accountLoading">
        <b-spinner small></b-spinner>
        <span class="ms-2">Loading...</span>
      </div>
      <div class="row" v-else>
        <treeselect 
            :multiple="true"
            :options="availableAccounts"
            :value-consists-of="availableAccountsConsist"
            :disable-branch-nodes="true"
            :limit="5"
            :max-height="300"
            v-model="newData"
            :clearOnSelect="true" 
        />
      </div>
      <template #modal-footer>
        <b-button variant="primary" @click="saveAccounts"> Save </b-button>
        <b-button variant="link" @click="clear"> Close </b-button>
      </template>
    </b-modal>
  </div>
</template>
<style lang="scss">
.p-custom-class .popover-body {
  padding: 0 !important;
  border: 0 !important;
}

.p-custom-class .list-group-item {
  border: 0 !important;
}
</style>
